import {Component, React, observer} from '$src/handy'
import * as css from './HCStatusButton.css'
import GenericButton from '$src/common/GenericButton'
import {HousingCorporation} from '$src/bootstrap/Store'
import EditAddressModal from '$src/housingCorporations/EditAddressModal'

interface Props {
  css?: any
  housingCorporation: typeof HousingCorporation.Type
}

interface State {
  modalOpen: boolean
  optimisticState: null | boolean
}

@observer
export default class AddressButton extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      modalOpen: false,
      optimisticState: null,
    }
  }

  render() {
    const {props} = this
    const {housingCorporation} = props

    return (
      <GenericButton
        variant="round"
        withMargin
        css={{container: css.button}}
        onClick={this.buttonClick}
      >
        Edit address
        {this.state.modalOpen && (
          <EditAddressModal
            cid={housingCorporation._id}
            onRequestClose={this.closeModal}
            onUpdateNeeded={(address: string) => {
              housingCorporation.setAddress(address)
            }}
          />
        )}
      </GenericButton>
    )
  }

  closeModal = () => {
    this.setState({modalOpen: false})
  }

  buttonClick = async () => {
    this.setState({modalOpen: true})
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/AddressButton.tsx